import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './modal.module.css';
import fondo from "../../assets/Gq_pacidad_2.png";
import logo from "../../assets/Gq_pacidad_3.png"; // Asegúrate de importar tu logo

const ModalTratDatos = ({ showDataModal, setShowDataModal }) => {


    return (
        <Modal
            show={showDataModal}
            onHide={() => setShowDataModal(false)}
            dialogClassName={styles.modalData}
            size="lg"
        >
            <Modal.Header closeButton className={styles.modalHeader}>
                <Modal.Title className={styles.modalTitle}>Política de Protección y Privacidad de Datos Personales</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                {/* Logo centrado absolutamente */}
                <div className={styles.logoCentrado}>
                    <img src={logo} alt="Logo" className={styles.logo} />
                </div>
                
                <div className={styles.principal}>
                    <div className={styles.container}>
                        <h1>Política de Tratamiento de Datos en Colombia</h1>
                        <section>
                            <p>
                                Con el fin de garantizar y proteger el derecho constitucional que todas las personas tienen a conocer, actualizar, rectificar y suprimir sus datos personales almacenados en bases de datos, se pone a disposición de los titulares de los datos personales la presente política para el uso, administración, transmisión y demás actividades relacionadas con el tratamiento de datos personales.
                            </p>
                            <p>
                                La Sociedad se compromete a proteger la privacidad y la confidencialidad de la información, de acuerdo con la Constitución, la Ley 1581 de 2012, el Decreto 1377 de 2013, el Decreto 1081 de 2015, el Decreto 255 de 2022 y demás normativas vigentes.
                            </p>
                        </section>
                        {/* Resto del contenido del modal */}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
                <Button variant="secondary" onClick={() => setShowDataModal(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalTratDatos;